<template>
    <div>


            <!-- Modal -->
            <div class="modal fade" :id="'vmbc'+ id" role="dialog">
                <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{service.name}}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>

                    <div class="modal-body">
                        <input type="number" class="form-control mt-1" v-model="service.price" placeholder="price">
                        <input type="text" class="form-control mt-1" v-model="service.xero" placeholder="xero">
                        <input type="text" class="form-control mt-1" v-model="service.notes" placeholder="notes">
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" @click="updateService(service)"><i class="fa fa-save"></i></button>
                        <button type="button" class="btn btn-default" data-dismiss="modal"><i class="fa fa-times"></i></button>
                    </div>
                </div>

                </div>
            </div>
    </div>
</template>
<script>
export default {
    props: ['id', 'service'],
    methods: {
        updateService(service){
            axios.post('./api/Service/Update', {
                    id: service.id,
                    name: service.name,
                    user_id: this.$root.id,
                    name_user: this.$root.staffname,
                    xero: service.xero,
                    price: service.price,
                    notes: service.notes
                })
                .then(function (response) {
                    console.log(response);
                    $('.modal').modal('hide');
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }

}
</script>



// WEBPACK FOOTER //
// resources/js/Item/Service/Edit.vue